import Phaser from "phaser";
import { Preferences } from "./Preferences";
import { GameConstants } from "./GameConstants";

type AudioSprite = ReturnType<Phaser.Sound.BaseSoundManager["addAudioSprite"]>;
type Effect = "click" | "card_flip" | "card_move" | "win" | "fail1";

export class AudioManager {
    private static effects?: AudioSprite;
    private static music?: AudioSprite;
    private static destroyed = true;
    private static initialized = false;
    private static scene: Phaser.Scene;

    public static init(scene: Phaser.Scene): void {
        AudioManager.initialized = true;
        AudioManager.onSceneChanged(scene);
    }

    public static onSceneChanged(scene: Phaser.Scene, gameplay = false): void {
        if (!AudioManager.initialized) return;
        scene.sound.setMute(GameConstants.MUTE_AUDIO);
        AudioManager.destroy();
        AudioManager.scene = scene;
        AudioManager.destroyed = false;
        if (scene.sound instanceof Phaser.Sound.NoAudioSoundManager) {
            console.warn("Audio is not available on this device");
            Preferences.notice = "Audio is not available on this device.";
        } else {
            AudioManager.effects = scene.sound.addAudioSprite("audiosprite", { mute: Preferences.sfxMuted });
            AudioManager.effects.setMute(Preferences.sfxMuted);
            if (gameplay) AudioManager.music = scene.sound.addAudioSprite("audiosprite", { mute: Preferences.musicMuted });
            if (scene.sound.locked) scene.sound.once(Phaser.Sound.Events.UNLOCKED, AudioManager.startMusic, AudioManager);
            else AudioManager.startMusic();
        }
        scene.input.on(Phaser.Input.Events.GAMEOBJECT_DOWN, AudioManager.onObjectDown, AudioManager);
        scene.events.once(Phaser.Scenes.Events.SHUTDOWN, AudioManager.destroy, AudioManager);
    }

    public static playEffect(key: Effect): void {
        if (AudioManager.destroyed || !AudioManager.effects || Preferences.sfxMuted || AudioManager.scene.sound.locked) return;
        if (!AudioManager.effects.play(key, { mute: Preferences.sfxMuted })) console.warn(`Could not play audio effect: ${key}`);
    }

    public static toggleMusic(): void {
        Preferences.setMusicMuted(!Preferences.musicMuted);
        AudioManager.music?.setMute(Preferences.musicMuted);
        AudioManager.playEffect("click");
    }

    public static toggleSfx(): void {
        Preferences.setSfxMuted(!Preferences.sfxMuted);
        AudioManager.effects?.setMute(Preferences.sfxMuted);
        AudioManager.playEffect("click");
    }

    private static startMusic(): void {
        if (AudioManager.destroyed || !AudioManager.music || AudioManager.music.isPlaying) return;
        if (!AudioManager.music.play("bridge_club_game_sountrack_cafe-swing", {
            loop: true, volume: .6, mute: Preferences.musicMuted
        })) console.warn("Could not start the board soundtrack");
    }

    private static onObjectDown(_pointer: Phaser.Input.Pointer, object: Phaser.GameObjects.GameObject): void {
        if (!object.getData("audioControl")) AudioManager.playEffect("click");
    }

    private static destroy(): void {
        if (AudioManager.destroyed) return;
        AudioManager.destroyed = true;
        AudioManager.scene.events.off(Phaser.Scenes.Events.SHUTDOWN, AudioManager.destroy, AudioManager);
        AudioManager.scene.sound.off(Phaser.Sound.Events.UNLOCKED, AudioManager.startMusic, AudioManager);
        AudioManager.scene.input.off(Phaser.Input.Events.GAMEOBJECT_DOWN, AudioManager.onObjectDown, AudioManager);
        AudioManager.music?.destroy();
        AudioManager.effects?.destroy();
        AudioManager.music = undefined;
        AudioManager.effects = undefined;
    }
}
